/* eslint-disable */
import * as React from 'react'
import PropTypes from 'prop-types'
import is from 'is_js'

class Dropdown extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    keys: PropTypes.array,
    isOpen: PropTypes.bool,
    withMouseLeave: PropTypes.bool,
    onMouseLeave: PropTypes.func,
    closeOpen: PropTypes.func,
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    children: PropTypes.func,
  }

  static defaultProps = {
    className: '',
    keys: [],
    isOpen: false,
    withMouseLeave: false,
    onMouseLeave: () => {},
    closeOpen: () => {},
    component: () => null,
    children: () => null,
  }

  constructor(props) {
    super(props)
    this.state = {
      isOpen: props.isOpen,
    }
  }

  componentDidMount() {
    if (is.function(this.props.onMouseLeave)) {
      window.addEventListener('mouseover', this._onHoveredOutside)
      window.addEventListener('touchstart', this._onHoveredOutside)
    }
    window.document.body.addEventListener('click', this._clickBody)
  }

  componentDidUpdate(prevProps) {
    const { isOpen } = this.props
    if (prevProps.isOpen !== isOpen) {
      this.setState({ isOpen: isOpen })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('mouseover', this._onHoveredOutside)
    window.removeEventListener('touchstart', this._onHoveredOutside)
    window.document.body.removeEventListener('click', this._clickBody)
  }

  _node = React.createRef()

  _clickBody = evt => {
    if (this._node.current && !this._node.current.parentElement.contains(evt.target)) {
      this.setState({ isOpen: false }, () => {
        const { closeOpen } = this.props
        closeOpen && closeOpen()
      })
    }
  }

  _onHoveredOutside = evt => {
    if (!this.props.isOpen || !this._node) return
    if (this._node.current && this._node.current.parentElement.contains(evt.target)) {
      return
    }
    this.props.onMouseLeave()

    if (this.props.withMouseLeave) {
      this.setState({ isOpen: false }, () => {
        const { closeOpen } = this.props
        closeOpen && closeOpen()
      })
    }
  }

  render() {
    const { className, keys, component: ChildComponent, children } = this.props
    const { isOpen } = this.state
    if (!isOpen) return null
    return (
      <ChildComponent className={className} ref={this._node}>
        {is.array(keys) && keys.length && is.function(children)
          ? keys.map((key, index) => children({ key, index }))
          : { children }}
      </ChildComponent>
    )
  }
}

export default Dropdown
